import styles from './EmptyState.module.scss'

interface EmptyStateProps {
  title: string
  description: string
}

export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div className={styles.state}>
      <div className={styles.title}>{title}</div>
      <div>{description}</div>
    </div>
  )
}
